// extracted by mini-css-extract-plugin
export default {"root":"MenuItem_root__wIT1z","focused":"MenuItem_focused__slXKU","title":"MenuItem_title__nHzAx","startIcon":"MenuItem_startIcon__exLpV","endIcon":"MenuItem_endIcon__v+p5x"};